import Tooltip from 'components/tooltips/Tooltips';

/**
 * Hover and keyboard-focus label for a button that only shows an icon: the
 * admin's one tooltip (components/tooltips), drawn over the page so that a
 * card's edge never cuts it. Visual only: the button keeps its own
 * aria-label, which carries the text.
 */
const IconTooltip = ({ label, placement = 'top', children }) => (
  <Tooltip text={label} placement={placement} space={8} testId="icon-tooltip">
    <span className="relative inline-flex shrink-0">{children}</span>
  </Tooltip>
);

export default IconTooltip;
